import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import MyPerformance from "../components/MyPerformance/MyPerformance";
import QBR from "../components/QBR/QBR";
import SideNavigation from "../components/SideNavigation/SideNavigation";
import ChatFlow from "../components/ChatFlow/ChatFlow";

function HomePage({
  view,
  handleViewChange,
  open,
  handleInputValue,
  chatscroll,
  setChatScroll,
  sessionId,
  handleChats,
  handleDrawerOpen,
  handleDrawerClose,
}) {
  const authUser = useSelector((state) => state.auth.user);
  const authLoading = useSelector((state) => state.auth.loading);
  const role = authUser?.business_function || "";
  const isSalesRep = role === "SALESREP";

  useEffect(() => {
    if (authLoading) return;
    if (view === "qbr" && !isSalesRep) {
      handleViewChange(null, "performance");
    }
  }, [authLoading, view, isSalesRep, handleViewChange]);

  const effectiveView =
    !authLoading && view === "qbr" && !isSalesRep ? "performance" : view;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          pt: "92px",
          pb: 1,
          ml: open ? "326px" : "60px",
          position: "sticky",
          top: "0",
          backgroundColor: "#f9fdff",
          zIndex: 9,
        }}
      >
        <ToggleButtonGroup
          value={effectiveView}
          exclusive
          onChange={handleViewChange}
          aria-label="Primary view toggle"
          sx={{
            border: "1px solid #E6E6E6",
            bgcolor: "#FFFFFF",
            borderRadius: "24px",
            p: "8px",
            height: "25px",
            color: "#202020",
            "& .MuiToggleButton-root": {
              textTransform: "none",
              border: 0,
              px: "2px",
              borderRadius: "16px",
            },
            "& .MuiToggleButton-root.Mui-selected": {
              bgcolor: "#396D87",
              color: "#FFFFFF",
            },
            "& .MuiToggleButton-root.Mui-selected:hover": {
              bgcolor: "#396D87",
            },
            "& .MuiToggleButton-root:not(.Mui-selected):hover": {
              bgcolor: "#F2EFEF",
            },
            "& .MuiToggleButton-root:not(.Mui-selected)": {
              color: "#202020",
            },
          }}
        >
          <ToggleButton value="performance" sx={{ mr: "1px", width: "128px" }}>
            My Performance
          </ToggleButton>
          <ToggleButton sx={{ mr: "1px", width: "128px" }} value="repassist">
            RepAssist
          </ToggleButton>
          {isSalesRep && (
            <ToggleButton sx={{ width: "128px" }} value="qbr">
              QBR
            </ToggleButton>
          )}
        </ToggleButtonGroup>
      </Box>

      <Box sx={{ display: effectiveView === "repassist" ? "block" : "none" }}>
        <ChatFlow
          handleInputValue={handleInputValue}
          drawerOpen={open}
          chatscroll={chatscroll}
          setChatScroll={setChatScroll}
          sessionId={sessionId}
          handleChats={handleChats}
        />
      </Box>

      <Box sx={{ display: effectiveView === "performance" ? "block" : "none" }}>
        <MyPerformance drawerOpen={open} isActive={effectiveView === "performance"} />
      </Box>

      {isSalesRep && (
        <Box sx={{ display: effectiveView === "qbr" ? "block" : "none" }}>
          <QBR isActive={effectiveView === "qbr"} />
        </Box>
      )}

      <Box sx={{ display: effectiveView === "repassist" ? "block" : "none" }}>
        <SideNavigation
          open={open}
          handleDrawerOpen={handleDrawerOpen}
          handleDrawerClose={handleDrawerClose}
        />
      </Box>
    </>
  );
}
export default HomePage;
